import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue-tl-tlbs-offer-renewal-alumni-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pullout" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Reduced from $6,000 to $5,000 for 6 months, paid in full, up front.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "We're excited to invite you back to Thought Leaders with this unique opportunity to join for 6 months, instead of 12, for a discounted enrolment of $5,000 AUD* ($1000 OFF). "),
  /*#__PURE__*/_createElementVNode("p", null, "Please review the below commitment agreement, and proceed with payment authorisation at the bottom of the page. This offer expires June 30th 5pm AEST."),
  /*#__PURE__*/_createElementVNode("p", null, "*Plus GST for Australian residents")
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "This End Of Financial Year renew offer is valid for The School alumni only, and vaild until the end of June."),
  /*#__PURE__*/_createElementVNode("li", null, "The discounted fee of $5,000 (AUD plus GST for AU residents) covers 6 months of The School tuition."),
  /*#__PURE__*/_createElementVNode("li", null, "Monthly or annual enrolment cannot be deferred or suspended."),
  /*#__PURE__*/_createElementVNode("li", null, "All fees are non-refundable, non-transferable, and cannot be used as credit or to redeem other services or events.")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroImageComponent = _resolveComponent("HeroImageComponent")!
  const _component_TlbsCommitmentAgreementComponent = _resolveComponent("TlbsCommitmentAgreementComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeroImageComponent, {
      "sub-title": "The School",
      title: "Alumni Renewal Offer"
    }),
    _hoisted_2,
    _createVNode(_component_TlbsCommitmentAgreementComponent, {
      "is-renewal": true,
      "plan-ids": [_ctx.ChargebeePlanIdEnum.BusinessSchoolOfferAlumni5k],
      "renewal-type": _ctx.TlbsRenewalTypeEnum.Alumni
    }, {
      "slot-cancellation": _withCtx(() => [
        _hoisted_3
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["plan-ids", "renewal-type"])
  ]))
}